import { createContext, useState, useContext } from "react";
import { Doctor, DoctorImage, DoctorUser } from "../models";

type DoctorContextType = {
	users?: DoctorUser[];
	setUsers: (value?: DoctorUser[]) => void;
	refreshUsers: boolean;
	setRefreshUsers: (value: boolean) => void;
	refreshTelehealthDoctors: boolean;
	setRefreshTelehealthDoctors: (value: boolean) => void;
	activeTelehealthDoctors?: Doctor[];
	setActiveTelehealthDoctors: (value: Doctor[]) => void;
	telehealthDoctors?: Doctor[];
	setTelehealthDoctors: (value: Doctor[]) => void;
	faceToFaceDoctors?: Doctor[];
	setFaceToFaceDoctors: (value: Doctor[]) => void;
	refreshFaceToFaceDoctors: boolean;
	setRefreshFaceToFaceDoctors: (value: boolean) => void;
	doctorImages?: DoctorImage[];
	setDoctorImages: (value: DoctorImage[]) => void;
	refreshDoctorImages: boolean;
	setRefreshDoctorImages: (value: boolean) => void;
};

type DoctorContextTypeProviderProps = {
	children: React.ReactNode;
};

const DoctorContext = createContext<DoctorContextType | undefined>(undefined);

export const DoctorProvider = ({
	children
}: DoctorContextTypeProviderProps) => {
	const [users, setUsers] = useState<DoctorUser[] | undefined>(undefined);
	const [refreshUsers, setRefreshUsers] = useState<boolean>(false);
	const [refreshTelehealthDoctors, setRefreshTelehealthDoctors] =
		useState<boolean>(false);
	const [activeTelehealthDoctors, setActiveTelehealthDoctors] = useState<
		Doctor[]
	>([]);
	const [telehealthDoctors, setTelehealthDoctors] = useState<Doctor[]>([]);
	const [faceToFaceDoctors, setFaceToFaceDoctors] = useState<Doctor[]>([]);
	const [refreshFaceToFaceDoctors, setRefreshFaceToFaceDoctors] =
		useState<boolean>(false);
	const [doctorImages, setDoctorImages] = useState<DoctorImage[]>([]);
	const [refreshDoctorImages, setRefreshDoctorImages] =
		useState<boolean>(false);

	return (
		<DoctorContext.Provider
			value={{
				users,
				setUsers,
				refreshUsers,
				setRefreshUsers,
				activeTelehealthDoctors,
				setActiveTelehealthDoctors,
				refreshTelehealthDoctors,
				setRefreshTelehealthDoctors,
				telehealthDoctors,
				setTelehealthDoctors,
				faceToFaceDoctors,
				setFaceToFaceDoctors,
				refreshFaceToFaceDoctors,
				setRefreshFaceToFaceDoctors,
				doctorImages,
				setDoctorImages,
				refreshDoctorImages,
				setRefreshDoctorImages
			}}
		>
			{children}
		</DoctorContext.Provider>
	);
};

export const useDoctorContext = () => {
	const context = useContext(DoctorContext);
	if (context === undefined) {
		throw new Error("useDoctorContext must be used within a DoctorProvider");
	}
	return context;
};
